/** Sidebar sections, in design order. */
export const navItems = [
  { to: '/', label: 'Home' },
  { to: '/deployments', label: 'Deployments' },
  { to: '/licenses', label: 'Licenses' },
  { to: '/releases', label: 'Releases' },
  { to: '/logs', label: 'Logs' },
  { to: '/team', label: 'Team & security' },
  { to: '/messages', label: 'Messages & reports' },
] as const;
